

import { useFormik } from "formik";
import * as yup from 'yup';
import { useCallback, useEffect, useMemo } from "react";
import { initialValues } from "../constants/constants";
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { getData, getErrorMessage, getStatus } from "@/store/slices/helpers/helpers";
import { clearData, fetchData } from "@/store/slices/fetch-slice";
import { apiKeys, apiMethods, apiStatuses, apiUrls } from "@/store/api/constants";
import { useNavigate } from "react-router";
import { getDecoded, getFormattedPayload, getFormattedResponse } from "@/common/helpers/helpers";
import { useParams } from "react-router-dom";
import navs from "@/from-theme/routes/constants/nav";
 
function useCreateEditSchemeNonEligibleApproval({isEditMode, getPlant}) {
  const {id: competitorIdEncoded} = useParams();
  const competitorId = getDecoded(competitorIdEncoded);
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const state = useSelector((store) => store);
 
  const updateCompetitorMasterStatus = getStatus(state, apiKeys.updateCompetitorMaster, '');
  const updateSchemesListMasterStatus = getStatus(state, apiKeys.updateSchemesListMaster, ''); 
  const getEditSchemesListMasterData = getData(state, 
    apiKeys.getEditSchemesNonEligibleListMaster, {});
  const getEditSchemesListMasterStatus = getStatus(state, 
    apiKeys.getEditSchemesNonEligibleListMaster, "");
  const getEditSchemesListMasterErrMsg = getErrorMessage(
    state,
    apiKeys.getEditSchemesNonEligibleListMaster,
    formatMessage({ id: "failed-to-get-selected-competitor-details" })
  );

  const validationSchema = yup.object({
    // schemeTotal: yup.string().nullable(),
    // schemeTypeName: yup.string().nullable(),
    // schemeName: yup.string().nullable(),
    // schemeId: yup.string().nullable(),
    // noOfCustomerCount: yup.string().nullable(),
    // activeStatus: yup.boolean().nullable(),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      if(isEditMode){
        // alert(1)
        console.log('onSubmit-values',values)
        let array_map = values.childData
        let selectedRowsData = [] 
        let avg_rule_not_selected = 0
        let avg_sales_not_calculated = 0
        array_map.map((vv,kk)=>{
          console.log('onSubmit-values vv',vv)
          console.log('onSubmit-values kk',kk)
          if(vv.selected == 1)
          {
            vv.avgRuleOverAllGroupId = values.avgRuleOverAllGroupId
            selectedRowsData.push(vv)
            if(!vv.avgRule_id)
            {
              avg_rule_not_selected = 1
            }
            if(!vv.avgSales_index)
            {
              avg_sales_not_calculated = 1
            }
          }
        })
        console.log('selectedRowsData',selectedRowsData)
        // console.log('onSubmit-values',selectedRowsData)
        if(!selectedRowsData || selectedRowsData.length == 0){
          alert('Customer List Need to Selected..')
          return false
        }

        if(avg_rule_not_selected == 1 && values.avgRuleOverAllGroupId == ''){
          alert('One of the Customer`s average rule was not selected..')
          return false
        }

        if(avg_sales_not_calculated == 1){
          alert('One of the Customer`s average sales was not fetched..')
          return false
        }

        // values.updateData = JSON.stringify(selectedRowsData)
        // updateSchemesListMaster(values)
        updateSchemesListMaster(selectedRowsData)
        // updateCompetitorMaster(values)

      }else{
        alert(2)
        saveCompetitorMaster(values)
      }
    }
  });

  const { values } = formik;
  const { divisionId } = values;

  useEffect(() => {
    let payload;
    if (divisionId) {
      // set data 
      payload = getFormattedPayload({ divisionId });
      getPlant(payload);
      // clear data 
      formik.setFieldValue('userPlantId', undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [divisionId, getPlant]);

  
  formik.fields = validationSchema?.fields;
  formik.schema = validationSchema;
  const getEditSchemesListMaster = useCallback(() => {
    dispatch(
      fetchData({
        url: apiUrls.getEditSchemesNonEligibleListMaster(competitorId),
        method: apiMethods.GET,
        key: apiKeys.getEditSchemesNonEligibleListMaster,
        failureMsg: formatMessage({ id: "failed-to-get-selected-competitor-details" }),
      })
    );
  }, [dispatch, formatMessage, competitorId]);

  const goBack = useCallback(() => {
    navigate(navs.schemeNonEligibleListView);
  }, [navigate]);

  useEffect(() => {
    if (isEditMode) {
      getEditSchemesListMaster()
    }
  }, [isEditMode, getEditSchemesListMaster]);

  useEffect(() => {
    if (getEditSchemesListMasterStatus === apiStatuses.succeeded) {
      formik.setValues(getFormattedResponse(getEditSchemesListMasterData));
    }
}, [ getEditSchemesListMasterData]);


  const saveCompetitorMaster = useCallback((values) => {
    dispatch(
      fetchData({
        url: apiUrls.saveCompetitorMaster,
        method: apiMethods.POST,
        key: apiKeys.saveCompetitorMaster,
        successMsg: formatMessage({ id: "competitor-master-is-saved-successfully" }),
        failureMsg: formatMessage({ id:  "competitor-master-is-failed-to-save" }),
        body: getFormattedPayload(values)
      })
    );
  }, [dispatch, formatMessage]);

  const updateSchemesListMaster = useCallback((values) => {
    dispatch(
      fetchData({
        url: apiUrls.updateSchemesListMaster,
        method: apiMethods.POST,
        key: apiKeys.updateSchemesListMaster,
        successMsg: formatMessage({ id: "scheme-list-master-is-updated-successfully" }),
        failureMsg: formatMessage({ id: "scheme-list-master-is-failed-to-update" }),
        // body: getFormattedPayload({ ...values, id: isEditMode })
        body: getFormattedPayload({ ...values})
        // body: getFormattedPayload(values)
      })
    );
  }, [dispatch, formatMessage, isEditMode]);

  // useEffect(() => {
  //   if (saveCompetitorMasterStatus === apiStatuses.succeeded) {
  //     navigate(navs.ifdCompetitorMaster)
  //   }
  // }, [saveCompetitorMasterStatus, navigate])

  useEffect(() => {
    if (updateCompetitorMasterStatus === apiStatuses.succeeded) {
      navigate(navs.ifdCompetitorMaster)
    }
  }, [updateCompetitorMasterStatus, navigate])
  
  useEffect(() => {
    if (updateSchemesListMasterStatus === apiStatuses.succeeded) {
      navigate(navs.schemeStatusListView)
    }
  }, [updateSchemesListMasterStatus, navigate])

  useEffect(() => () => {
    dispatch(clearData({ key: apiKeys.getAreaMaster }));
    dispatch(clearData({ key: apiKeys.getDropdownListMaster }));
    dispatch(clearData({ key: apiKeys.getCityMaster }));
    // dispatch(clearData({ key: apiKeys.saveCompetitorMaster }));
    dispatch(clearData({ key: apiKeys.updateCompetitorMaster }));
    dispatch(clearData({ key: apiKeys.updateSchemesListMaster }));
    dispatch(clearData({ key: apiKeys.getEditSchemesListMaster }));
  }, [dispatch])

  return useMemo(() => ({
    formik,
    values: formik.values,
    // saveCompetitorMasterStatus,
    updateCompetitorMasterStatus,
    updateSchemesListMasterStatus,
    // saveCompetitorMasterLoading,
    getEditSchemesListMasterData,
    getEditSchemesListMasterStatus,
    getEditSchemesListMasterErrMsg,
    goBack
  }), [
    formik,
    // saveCompetitorMasterStatus,
    updateCompetitorMasterStatus,
    updateSchemesListMasterStatus,
    // saveCompetitorMasterLoading,
    getEditSchemesListMasterData,
    getEditSchemesListMasterStatus,
    getEditSchemesListMasterErrMsg,
    goBack
  ])
}

export default useCreateEditSchemeNonEligibleApproval